import { ADMIN_STORAGE, USER_STORAGE } from '@/constants/storage';

export type AuthKind = 'user' | 'admin';

const storageMap = {
  user: USER_STORAGE,
  admin: ADMIN_STORAGE,
} as const;

export function getStoredToken(kind: AuthKind): string | null {
  return localStorage.getItem(storageMap[kind].token);
}

export function getStoredRefreshToken(kind: AuthKind): string | null {
  return localStorage.getItem(storageMap[kind].refreshToken);
}

export function persistTokens(kind: AuthKind, accessToken: string, refreshToken: string): void {
  localStorage.setItem(storageMap[kind].token, accessToken);
  localStorage.setItem(storageMap[kind].refreshToken, refreshToken);
}

export function clearAuthStorage(kind: AuthKind): void {
  localStorage.removeItem(storageMap[kind].token);
  localStorage.removeItem(storageMap[kind].refreshToken);
  if (kind === 'user') {
    localStorage.removeItem(USER_STORAGE.user);
  } else {
    localStorage.removeItem(ADMIN_STORAGE.admin);
  }
}

export function isAuthEndpoint(url?: string): boolean {
  if (!url) return false;
  return url.includes('/auth/users') || url.includes('/auth/admins');
}

export function resolveAuthKind(url?: string): AuthKind {
  if (url?.includes('/auth/admins') || url?.includes('/admins')) {
    return 'admin';
  }
  return 'user';
}

export function decodeJwtPayload(token: string): { exp?: number; iat?: number } | null {
  try {
    const segment = token.split('.')[1];
    if (!segment) return null;
    const normalized = segment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
    return JSON.parse(atob(padded)) as { exp?: number; iat?: number };
  } catch {
    return null;
  }
}

export function isTokenExpired(token: string | null, bufferSeconds = 30): boolean {
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000 - bufferSeconds * 1000;
}
